import { memo } from 'react';
import InlineAttachment from './InlineAttachment';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const InlineAttachments = ({
  fileAttachments,
  genericChannelId
}) => {
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "inline-attachments-wrapper",
    cursor: "pointer",
    inlineSize: "100%",
    display: "block",
    marginBlockEnd: "400",
    marginBlockStart: "200",
    children: fileAttachments.map((fileAttachment, index) => /*#__PURE__*/_jsx(InlineAttachment, {
      fileAttachment: fileAttachment,
      genericChannelId: genericChannelId
    }, `attachment-${index}`))
  });
};
InlineAttachments.displayName = 'InlineAttachments';
export default /*#__PURE__*/memo(InlineAttachments);